const youtube = (window.lp && window.lp.video && window.lp.video.youtube) || {};
const { apiSettings, aspectRatio, server } = youtube;
const videoOptions = {
	apiSettings,
	aspectRatio,
	server
};

export default videoOptions;
